import { store } from "redux/store";

const isResourceAvailable = (resource, action) => {
  let resourceData = store.getState()?.data?.userResources;

  if (resourceData?.resources && resourceData?.resources[resource]) {
    if (Array.isArray(resourceData?.resources[resource])) {
      return resourceData?.resources[resource].includes(action);
    }
  }

  return false;
};

export default isResourceAvailable;
